/** Single sign-on API endpoints, merged into the platform API client. */
export const ssoApiEndpoints: Record<string, string> = {
  ssoConnection: "/ext/sso/connection/",
  saveSsoConnection: "PUT:/ext/sso/connection/",
  checkSsoIssuer: "POST:/ext/sso/connection/check/",
  verifySsoDomains: "POST:/ext/sso/connection/verify/",
  platformSignIn: "/ext/sso/platform/",
  savePlatformSignIn: "PUT:/ext/sso/platform/",
};
